import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'
import useNonPaginatedRegisters from '@/modules/NonPaginatedRegisters.js'
import { ref } from 'vue'

const non_paginated_machine_classes = ref([])
const machine_classes = ref([])
const total_machine_classes = ref(0)
const machine_class_filters = ref({})
const loading = ref(false)

export default function useCompanies() {
  const {
    listRegisters,
    get_api_path,
    save_api_path,
    getAllRegisters,
    search_and_paginate_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  search_and_paginate_api_path.value = '/api/machine_classes/searchAndPaginate'
  get_api_path.value = '/api/machine_classes/get/'
  save_api_path.value = '/api/machine_classes/storeOrUpdate'
  destroy_api_path.value = '/api/machine_classes/destroy/'

  const listMachineClasses = async (page, per_page) => {
    loading.value = true

    return new Promise((resolve, reject) => {
      listRegisters(page, per_page, machine_class_filters.value)
        .then((response) => {
          total_machine_classes.value = response.data.meta.total
          machine_classes.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
        .finally(() => (loading.value = false))
    })
  }

  const destroyMachineClass = async (id, index) => {
    destroyRegister(id).then(() => {
      machine_classes.value.splice(index, 1)
    })
  }

  const { all_registers_api_path, listRegisters: listRegistersNoPagination } =
    useNonPaginatedRegisters()

  all_registers_api_path.value = '/api/machine_classes/all'

  const listMachineClassesNoPagination = async () => {
    return new Promise((resolve, reject) => {
      listRegistersNoPagination()
        .then((response) => {
          non_paginated_machine_classes.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
    })
  }

  const listMachineClassesNoPaginationToCompany = async (company_id) => {
    return new Promise((resolve, reject) => {
      listRegistersNoPagination()
        .then((response) => {
          non_paginated_machine_classes.value = response.data.data.filter(
            (x) => x.company_id === company_id,
          )
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
    })
  }

  return {
    machine_classes,
    non_paginated_machine_classes,
    listMachineClassesNoPagination,
    total_machine_classes,
    machine_class_filters,
    loading,
    listMachineClassesNoPaginationToCompany,
    listMachineClasses,
    destroyMachineClass,
    getAllMachineClasses: getAllRegisters,
    saveMachineClass: saveRegister,
    getMachineClass: getRegister,
  }
}
